import { AppShell } from "@web/components/layout/AppShell";
import { useTranslation } from "react-i18next";

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <AppShell>
      <h1 className="text-xl">404</h1>
      <p className="mt-2 text-ink-2">{t("errors.not_found")}</p>
    </AppShell>
  );
}
